import { injectGlobal } from 'emotion';
import { switchInput, switchCompact, switchWrapper } from '../styles/legacy';
import { errorSwitch as errorSwitchCitron, switchBase as switchCompactCitron, switchWrapper as switchWrapperCitron, combinators, } from '../styles/citron';
import { citrusStyled } from '@citrus/runtime';
export var switchLabelIdentifier = 'citrus-switch-label-c0d3d';
injectGlobal(combinators);
export var SwitchInput = citrusStyled.input('switchInput', switchInput); // There is no regular switch for citrus2022; only compact
export var SwitchError = citrusStyled.input('errorSwitch', errorSwitchCitron); // There is no error switch for legacy
export var SwitchCompactInput = citrusStyled.input('switchCompact', {
    legacy: switchCompact,
    citrus2022: switchCompactCitron,
});
export var SwitchLabel = citrusStyled.div('N/A', null, { classNames: [switchLabelIdentifier] });
export var SwitchWrapper = citrusStyled.div('switchWrapper', {
    legacy: switchWrapper,
    citrus2022: switchWrapperCitron,
});
export var LabelWrapper = citrusStyled.label('N/A', null);
export var Styled = {
    LabelWrapper: LabelWrapper,
    SwitchError: SwitchError,
    SwitchInput: SwitchInput,
    SwitchCompactInput: SwitchCompactInput,
    SwitchLabel: SwitchLabel,
    SwitchWrapper: SwitchWrapper,
};
